import Icon from './Icons';
import Acordeao from './Acordeao';
import faq from '../data/faq';
import { linkWhatsApp } from '../config';
import './Duvidas.css';

export default function Duvidas() {
  return (
    <section className="secao" id="duvidas">
      <div className="container duvidas__grade">
        <div className="duvidas__lateral">
          <span className="rotulo">Dúvidas Frequentes</span>
          <h2 className="titulo-secao">O que você precisa saber</h2>
          <p className="subtitulo-secao">
            Respostas objetivas para as perguntas que mais aparecem no primeiro
            contato. Elas não substituem a análise do seu caso.
          </p>

          <div className="duvidas__cartao">
            <p>Sua dúvida não está aqui?</p>
            <a
              className="btn btn--ouro btn--bloco"
              href={linkWhatsApp('Olá, tenho uma dúvida sobre um caso criminal.')}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="whatsapp" size={18} />
              Perguntar pelo WhatsApp
            </a>
          </div>
        </div>

        <div className="duvidas__lista">
          <Acordeao itens={faq} idBase="home" />
        </div>
      </div>
    </section>
  );
}
